<div
  [style.background-color]="backgroundColor"
  [style.color]="textColor"
  [style.opacity]="isSelected ? 0.6 : 1"
  (contextmenu)="$event.preventDefault()"
  class="custom-button" [ngClass]="isSelected !== undefined && isSelected ? ' btn btn-sm btn-selected' : 'btn btn-sm btn-unselected'">
  {{name}}
</div>